import {
  registerAdmin,
  verifyToken,
  resetState,
} from "../../../modules/adminRegister";
import { closeModalGoHome, setOpenAuthModal } from "../../../modules/login";

const initialState = {};

export const registerAdminReducer = (state = initialState, action) => {
  return state;
};

export const mapStateToProps = (state) => {
  return state.adminRegisterReducer;
};

export const mapDispatchToProps = {
  closeModalGoHome,
  setOpenAuthModal,
  registerAdmin,
  verifyToken,
  resetState,
};
